// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__mf_MQ","header":"ReportDetails_header__1vL0n","title":"ReportDetails_title__1Eoaw","left":"ReportDetails_left__2aAhT"};